<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items' : ''">
		<div class="bgfff" :style="openType != 'mob' ? 'height:700px;' : ''" style="height: 100vh;"
			:class="openType != 'mob' ? 'container_w_h' : 'vh100 w100'">
			<div class="top page_bg" id="top" :style="'height:' + H + 'px;'+(openType != 'mob' ? 'pc-top' : '')">
				<div class="top-s flex flex_center flex_items" style="height: 80px;">
					<div class="txt_center" :class="handleClick == 0 ? 'main_bg cf' : ''" @click="handleChange(0)">发放
					</div>
					<!-- <div class="txt_center ml20" :class="handleClick == 1 ? 'main_bg cf' : ''" @click="handleChange(1)">
						冲销
					</div> -->
					<div class="txt_center ml20" :class="handleClick == 2 ? 'main_bg cf' : ''" @click="handleChange(2)">
						明细
					</div>
					<div class="txt_center ml20" :class="handleClick == 4 ? 'main_bg cf' : ''" @click="handleChange(4)">
						积分汇总
					</div>
				</div>
				<template v-if="handleClick == 2 || handleClick == 4">
					<!-- <div class="top-content bgfff pt20 plr20">
						<div class="mb20 txt_center">项目积分情况</div>
						<div class="flex flex_between flex_items ">
							<div class="">
								<div class="txt_center mb10">30</div>
								<div class="ca6">总积分</div>
							</div>
							<div class="">
								<div class="txt_center mb10">30</div>
								<div class="ca6">已发放</div>
							</div>
							<div class="">
								<div class="txt_center mb10">30</div>
								<div class="ca6">剩余积分</div>
							</div>
						</div>
					</div> -->
					<div class=" plr20 flex_items bgfff pb10">
						<div v-if="openType == 'mob'" class="bor_b flex flex_items flex_between"  @click="show1 = true"
							style="height: 60px;box-sizing: border-box;">
							<div class="flex1 flex flex_items">
								<div class="" style="width: 100px;">会员</div>
								<div :class="name.name1 ? '' : 'ca6'">{{name.name1 ? name.name1 : '请选择会员'}}</div>
							</div>
							<van-icon name="arrow" />
						</div>
						<div v-else class="bor_b flex flex_items flex_between"
							style="height: 60px;box-sizing: border-box;">
							<div class="" style="width: 100px;">会员</div>
							<el-select v-model="username" placeholder="请选择" @change="pcNameChange">
								<el-option v-for="item in list" :key="item.id" :label="item.name1" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<template v-if="handleClick == 2">
							<template v-if="openType == 'mob'">
								<div class="bor_b flex flex_items flex_between"
									style="height: 60px;box-sizing: border-box;">
									<div class="" @click="show2 = true">
										<div :class="timer ? '' : 'ca6'">{{timer ? timer : '选择开始日期'}}
											<van-icon name="arrow-down" />
										</div>
									</div>
									<div class="" @click="show3 = true">
										<div :class="timerEnd ? '' : 'ca6'">{{timerEnd ? timerEnd : '选择结束日期'}}
											<van-icon name="arrow-down" />
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="bor_b flex flex_items flex_between"
									style="height: 60px;box-sizing: border-box;">
									<el-date-picker format="yyyy-MM-dd" v-model="timer" class="mr10" align="right"
										@change="pcPicerChange" type="date" placeholder="请选择开始日期">
									</el-date-picker>
									<el-date-picker v-model="timerEnd" align="right" @change="pcPicerChange1"
										type="date" placeholder="请选择结束日期">
									</el-date-picker>
								</div>
							</template>
						</template>
					</div>
				</template>
			</div>
			<div class="content"
				:style="openType == 'mob' ?'padding-top:'+H +'px;' : 'padding-top:'+pcPt+'px'">
				<template v-if="handleClick != 2 && handleClick != 4">
					<div class=" plr20 flex_items">
						<div class="pt20 pb20 bor_b flex flex_between" v-if="openType == 'mob'">
							<div class="flex1 flex flex_items" @click="show1 = true">
								<div class="" style="width: 60px;">会员</div>
								<div :class="name.name1 ? '' : 'ca6'">{{name.name1 ? name.name1 : '请选择会员'}}</div>
							</div>
							<van-icon name="arrow" />
						</div>
						<div v-else class="bor_b flex flex_items flex_between"
							style="height: 60px;box-sizing: border-box;">
							<div class="" style="width: 60px;">会员</div>
							<el-select v-model="username" placeholder="请选择会员">
								<el-option v-for="item in list" :key="item.id" :label="item.name1" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<div class="pt20 pb20 bor_b">
							<div class="flex flex_items">
								<div class="" style="width: 60px;">{{handleClick == 0 ? '积分' : '冲销积分'}}</div>
								<input type="text" class="flex1" v-model="intergal" placeholder="正表示增加,负表示扣除" />
							</div>
						</div>
						<div class="pt20 pb20 bor_b">
							<div class="flex flex_items" style="align-items: flex-start;">
								<div class="" style="width: 60px;">备注</div>
								<textarea type="text" v-model="title" placeholder="请填写备注" />
							</div>
						</div>
					</div>
				</template>
				<template v-if="handleClick == 2">
					<div class="bgfff" v-for="(item, index) in sList" :key="index">
						<div class="bor_b plr20 pt20 pb20">
							<div class="flex_items flex_between mb10">
								<div class="" v-if="item.user">
									{{item.user ? item.user.name : ''}}({{item.user ? item.user.phone : ''}})
								</div>
								<div style="text-decoration: line-through;" v-else>用户已删除</div>
							</div>
							<div class="flex_items flex_between mb10">
								<div class="ca6">备注：{{item.title}}</div>
								<div :class="item.amount > 0 ? 'main_color' : 'red'">{{item.amount}}</div>
							</div>
							<div class="ca6">{{item.updated_at}}</div>
						</div>
					</div>
					<div class="empty" v-if="sList.length == 0">
						暂无数据
					</div>
				</template>
				<template v-if="handleClick == 4">
					<div class="bgfff" v-for="(item, index) in scoreInfoList" :key="index">
						<div class="bor_b plr10 pt10 pb10">
							<div class="flex_items flex_between mb10">
								<div class="">
									{{item.name ? item.name : ''}}
								</div>
								<div class="">
									总积分:{{item.score ? item.score.total : ''}}
								</div>
							</div>
							<div class="flex_items flex_between">
								<div>已冲销：{{item.score ?item.score.exchange : ''}}</div>
								<div>剩余积分：{{item.score ?item.score.remain : ''}}</div>
							</div>
						</div>
					</div>
					<div class="empty" v-if="scoreInfoList.length == 0">
						暂无数据
					</div>
				</template>
			</div>
			<div class="bottom_btn" @click="submit" v-if="handleClick != 2 && handleClick != 4">
				<div class="btn_contenbt">确定</div>
			</div>
			<div class="right-circle cf">
				<el-upload class="upload-demo" :action="action" :on-success="handleSuccess" multiple :limit="1"
					:show-file-list="false" :on-exceed="handleExceed" :file-list="fileList" :data="upData"
					:headers="headers" name="file" :before-upload="beforeUp">
					导入
				</el-upload>
			</div>
			<div class="right-circle cf overHidden" style="bottom: 150px;background-color: #00D8CC;">
				<form :action="url" method="post">
					<input type="hidden" name="api_token" :value="token" />
					<input type="hidden" name="project_id" :value="id" v-if="id"/>
					<button type="submit" style="background: #00D8CC;width: 100%;height: 100%;border: 0;">导出</button>
				</form>
			</div>
			<div class="right-circle cf overHidden flex flex_column flex_center"
				style="bottom: 220px;background-color: #00D8CC;font-size: 14px;">
				<div style="height: 15px;line-height: 1;">导入模</div>
				<div style="height: 15px;line-height: 1;">板下载</div>
				<form :action="url1" method="post" style="position: absolute;top:0;left: 0;width: 60px;">
					<input type="hidden" name="api_token" :value="token" />
					<input type="hidden" name="project_id" :value="id" v-if="id" />
					<button type="submit" style="opacity: 0;width: 100%;height: 60px;border: 0;"></button>
				</form>
			</div>
			<!-- 选择名字 -->
			<Popup v-model="show1" position="bottom">
				<Picker :show-toolbar="true" title=" " value-key="name1" :columns="list" @confirm="nameOnConfirm"
					@cancel="show1 = false" />
			</Popup>
			<!-- 选择时间 -->
			<Popup v-model="show2" position="bottom">
				<DatetimePicker v-model="timerS" @cancel="show2 = false" @confirm="confirm" type="date" title="选择开始日期">
				</DatetimePicker>
			</Popup>
			<Popup v-model="show3" position="bottom">
				<DatetimePicker v-model="timerSE" @cancel="show3 = false" @confirm="confirm1" type="date"
					title="选择结束日期">
				</DatetimePicker>
			</Popup>
		</div>
	</div>
</template>

<script>
	import {
		openType,
		pcContentHeight
	} from '@/utils/tool.js'
	import {
		List,
		Popup,
		DatetimePicker,
		Picker
	} from "vant";
	export default ({
		components: {
			List,
			Popup,
			DatetimePicker,
			Picker
		},
		data() {
			return {
				pcPt: 120,
				handleClick: 0,
				openType: openType(),
				list: [],
				allUser: [],
				show1: false,
				show2: false,
				show3: false,
				loading: false,
				finished: false,
				name: {}, //会员名
				intergal: '', //积分
				H: 80,
				timer: '',
				timerEnd: '',
				timerS: new Date(),
				timerSE: new Date(),
				username: '',
				title: '',
				flag: true,
				sList: [],
				selectObj: {},
				url: this.defUrl + '/api/score/export',
				url1: this.defUrl + '/download/score.xlsx',
				action: this.defUrl + '/api/score/import',
				token: localStorage.getItem('token'),
				headers: '',
				fileList: [],
				mask: null,
				upData: {},
				id: '',
				scoreInfoList: [], //积分汇总
			}
		},
		watch: {
			handleClick(n) {
				this.name = {};
				this.username = '';
				this.selectObj = {};
				this.timerS = new Date()
				this.timerSE = new Date()
				this.timer = ''
				this.timerEnd = ''
				if (n == 2) {
					// this.H = 400;
					this.H = 220;
					this.list = [{
						id: 0,
						name1: '全部'
					}].concat(this.allUser)
					this.getList()
				} else if (n == 0) {
					this.H = 80
					this.list = this.allUser
				} else {
					this.scoreInfo()
					this.list = [{
						id: 0,
						name1: '全部'
					}].concat(this.allUser)
					this.H = 160
				}
				if (this.openType != 'mob') {
					this.pcPt = pcContentHeight('top');
					// this.$forceUpdate()
				}
			}
		},
		methods: {
			handleExceed(files, fileList) {
				this.$message.warning(`超出文件上传数量`);
			},
			handleSuccess(response, file) {
				if (response.code == 0) {
					this.$message.success(response.message);
					localStorage.setItem('handleClick', 2)
					setTimeout(() => {
						location.reload();
					}, 2000)
					// 
				} else {
					this.$message.success(response.message);
					this.fileList = []
				}
				this.mask.close();
			},
			beforeUp(e) {
				this.mask = this.$loading({
					lock: true,
					text: "上传中",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				});
			},
			pcPicerChange() {
				let e = this.timer;
				this.selectObj.date_start = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.getList()
			},
			pcPicerChange1() {
				let e = this.timerEnd;
				this.selectObj.date_end = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.getList()
			},
			nameOnConfirm(e) {
				this.name = e;
				this.username = e.id;
				if (this.handleClick == 2) {
					this.selectObj.user_id = e.id;
					this.getList()
				}else if(this.handleClick == 4){
					this.selectObj.user_id = e.id;
					this.scoreInfo()
				}
				this.show1 = false
			},
			pcNameChange() {
				if (this.handleClick == 2) {
					this.selectObj.user_id = this.username;
					this.getList()
				}else if(this.handleClick == 4){
					this.selectObj.user_id = this.username
					this.scoreInfo()
				}
			},
			confirm(e) {
				let m = (e.getMonth() + 1).toString().length == 1 ? '0' + (e.getMonth() + 1) : (e.getMonth() + 1)
				this.selectObj.date_start = e.getFullYear() + '-' + m + '-' + e.getDate();
				this.timer = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show2 = false;
				this.getList()
			},
			confirm1(e) {
				let m = (e.getMonth() + 1).toString().length == 1 ? '0' + (e.getMonth() + 1) : (e.getMonth() + 1)
				this.selectObj.date_end = e.getFullYear() + '-' + m + '-' + e.getDate();
				this.timerEnd = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show3 = false;
				this.getList()
			},
			handleChange(e) {
				this.handleClick = e;
				this.neme = {};
				this.intergal = '';
				if (this.openType != 'mob') {
					this.$nextTick(() => {
						this.pcPt = pcContentHeight('top');
					})
				}
			},
			onLoad() {
				this.getData();
				this.page++;
			},
			submit() {
				if (!this.username) {
					this.Toast('请选择会员')
					return
				}
				if (!this.intergal) {
					this.Toast('请填写积分数额')
					return
				}
				if (!this.title) {
					this.Toast('请填写备注')
					return
				}
				if (!this.flag) {
					return
				}
				this.flag = false;
				let obj = {
					user_id: this.username,
					amount: this.intergal,
					title: this.title,
				}
				if (this.id) {
					obj.project_id = this.id
				}
				this.api
					.scoreNew(obj)
					.then((res) => {
						this.Toast('操作成功')
						this.title = '';
						this.username = '';
						this.intergal = '';
						this.name = {}
						this.flag = true;
					}).catch(res => {
						this.flag = true;
					});
			},
			getUserData() {
				if(this.id){
					this.api.projectUser({},this.id).then(res => {
						let arr = []
						res.data.map(r => {
							if(r.role == 'member'){
								r.name1 = r.name + r.phone;
								arr.push(r)
							}
						})
						this.allUser = arr;
						this.list = arr;
					})
				}else{
					this.api.accountList({
						type: 'member'
					}).then(res => {
						res.data.map(r => {
							r.name1 = r.name + r.phone
						})
						this.allUser = res.data;
						this.list = res.data;
					})
				}
				
			},
			getList() {
				if (this.id) {
					this.selectObj.project_id = this.id
				}
				this.api.scoreLogs(this.selectObj).then(res => {
					this.sList = res.data;
				})
			},
			handleSub(e) {
				let f = new FormData()
			},
			scoreInfo() {
				if (this.id) {
					this.selectObj.project_id = this.id
				}
				this.api.scoreInfo(this.selectObj).then(res => {
					this.scoreInfoList = res.data;
					// console.log(this.scoreInfoList)
				})
			}
		},
		created() {
			this.openType = openType();
			this.id = this.$route.query.id;
			if (this.id) {
				this.upData = {
					project_id: this.id
				}
			}
			this.getUserData();
			this.getList();
			this.scoreInfo(); //获取积分汇总
			if (localStorage.getItem('handleClick')) {
				this.handleClick = localStorage.getItem('handleClick')
			} else {
				this.handleClick = 0
			}
			this.headers = {
				Authorization: "Bearer " + this.token
			};
			if (this.openType != 'mob') {
				this.$nextTick(() => {
					this.pcPt = pcContentHeight('top');
				})
			}
		},
		destroyed() {
			localStorage.removeItem('handleClick')
		}
	})
</script>

<style scoped="scoped">
	.top-s>div {
		width: 85px;
		height: 40px;
		line-height: 40px;
		border-radius: 10px;
	}

	.top {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.top,
	.pc-top {
		width: 390px;
		left: 50%;
		transform: translateX(-50%);
	}

	.top-content {
		height: 130px;
		box-sizing: border-box;
	}

	.content {
		box-sizing: border-box;
		overflow-y: auto;
		height: 100%;
		padding-bottom: 250px;
	}

	textarea {
		border: 0;
		resize: none
	}
</style>
